/**
 * @generated SignedSource<<a93b0003a92928b0c8c80aae8840a318>>
 * @relayHash eba148c318a42a8a03af7139edd8bcb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 080f51b73dbfd5b8ecd4690222d8ed6fa54c88bc0c261f78a2737930d2f36bf5

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type srcAsyncCreateIssueTypeQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type srcAsyncCreateIssueTypeQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly issueTypes: {
        readonly " $fragmentSpreads": FragmentRefs<"ui_createIssueTypeModal_CreateIssueTypeModalWrapper">;
      };
    };
  };
};
export type srcAsyncCreateIssueTypeQuery = {
  response: srcAsyncCreateIssueTypeQuery$data;
  variables: srcAsyncCreateIssueTypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "srcAsyncCreateIssueTypeQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraIssueTypeConnection",
                      "kind": "LinkedField",
                      "name": "issueTypes",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.jiraProjectByKey.issueTypes"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProjectByKey"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "srcAsyncCreateIssueTypeQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "issueTypes",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "totalCount"
                  },
                  {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "concreteType": "JiraIssueTypeHierarchyLevel",
                            "kind": "LinkedField",
                            "name": "hierarchy",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "level"
                              }
                            ]
                          },
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "080f51b73dbfd5b8ecd4690222d8ed6fa54c88bc0c261f78a2737930d2f36bf5",
    "metadata": {},
    "name": "srcAsyncCreateIssueTypeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c2de4a5e60ef0aa0115dfe315cfefd73";

export default node;
